import React from "react";

import DashboardView from "./ui/DashboardView";

const DashboardScene = () => <DashboardView />;

export default DashboardScene;
